// auth action types
export const JOB_LIST = 'JOB_LIST'
export const JOB_DETAIL = 'JOB_DETAIL'
export const UPDATE_STATE = 'UPDATE_STATE'
export const UPDATE_BULK_COPY_CHECKBOX_STATE = 'UPDATE_BULK_COPY_CHECKBOX_STATE'
export const INIT_JOB_LIST = 'INIT_JOB_LIST'
export const INIT_JOB_ID_LIST = 'INIT_JOB_ID_LIST'

export default {
  JOB_LIST,
  JOB_DETAIL,
  UPDATE_STATE,
  UPDATE_BULK_COPY_CHECKBOX_STATE,
  INIT_JOB_LIST,
  INIT_JOB_ID_LIST,
}
